<template>
    <div>
        <modal class="add-policy-to-now" :display="modalStatus.bizAddPolicyToNow" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>添加到現有</h1>
            <div class="add-policy-to-now-wrap">
                <div class="added-policy">
                    <span v-if="selectedList.length == 0" class="placeholder">請添加下列政策</span>
                    <span v-else class="seleted" v-for="(list, index) in selectedList" :key="index">
                        {{list.policySettingSeq}}. {{wordLimit(list.policySettingContent, 12)}}
                        <img @click="removePolicy({selected: index,default: list.policySettingSeq-1})" src="@/assets/img/icon/modal_close_gray.svg" alt="" srcset="">
                    </span>
                </div>
                <div class="policies">
                    <div class="title">
                        請選擇您想添加的條款至您勾選的房源 
                    </div>
                    <div class="list">
                        <div class="item" v-for="(list, index) in landlordPolicyList" :key="index">
                            <div class="wrap" v-if="list.display === true">
                                <div class="policy">
                                    {{list.policySettingContent}}
                                </div>
                                <border-plus @click.native="addPolicy(index)"></border-plus>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button confirm" :disabled="status.isDisable" @click="createPolicy">
                        更新
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import borderPlus from '@/components/bussiness/widges/button/borderPlus.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            selectedList: [],
            landlordPolicyList: [],
            status: {
                isDisable: false,
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 3000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 3000
                }
            },
        }
    },
    watch: {
        defaultLandlordPolicyList: {
            handler: function (val) {
                this.landlordPolicyList = val
                this.setlandlordPolicyDisplay(true)
            },
            deep: true,
            immediate: true
        },
        selectedList: function (val){
            this.$store.dispatch('setSeletedPolicy', val)
        }
    },
    methods: {
        addPolicy: function (index) {
            this.landlordPolicyList[index].display = false
            this.selectedList.push(this.landlordPolicyList[index])
        },
        removePolicy: function (index) {
            console.log(index)
            this.selectedList.splice(index.selected, 1);
            this.landlordPolicyList[index.default].display = true
        },
        createPolicy: function () {
            if(this.selectedList.length){
                this.$store.dispatch('createBizBatchPolicy')
                .then(()=>{
                    this.closeModal()
                    this.selectedList = []
                    this.setlandlordPolicyDisplay(true)
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '成功添加政策',type: 'success'})
                })
            }else{
                this.alarm.error.msg = '尚未添加政策'
                this.alarm.error.status = true
            }
        },
        wordLimit: function (val, limit) {
            return val.substr(0,limit)+'...'
        },
        setlandlordPolicyDisplay: function (status) {
            for (let i = 0; i < this.landlordPolicyList.length; i++) {
                this.landlordPolicyList[i].display = status
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizAddPolicyToNow'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            defaultLandlordPolicyList: 'GET_BIZ_LANDLORD_POLICY_LIST',
        })
    },
    components: {
        Modal,
        btnLoading,
        borderPlus,
        alarmMsgWhite
    }
}
</script>
<style lang="scss">
    #modal.add-policy-to-now{
        .modal-content{
            width: 826px;
            height: 600px;
            padding: 0px;
            box-sizing: border-box;
            .detail{
                position: unset;
                align-items: flex-start;
                .alarm-msg{
                    left: 50%;
                    margin-left: -70px;
                }
                >h1{
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 16px;
                    line-height: 1.5;
                }
                .add-policy-to-now-wrap{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding: 0 32px;
                    box-sizing: border-box;
                    .added-policy{
                        width: 100%;
                        box-sizing: border-box;
                        padding: 12px 16px 0px 16px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background-color: #ffffff;
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        .placeholder{
                            color: #c5c2c1;
                            margin-bottom: 12px;
                        }
                        .seleted{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 236px;
                            border-radius: 2px;
                            background-color: #f3f3f3;
                            padding: 2px 2px 2px 8px;
                            box-sizing: border-box;
                            margin-right: 10px;
                            margin-bottom: 10px;
                            &:nth-child(3n){
                                margin-right: 0px;
                            }
                            img{
                                width: 24px;
                                cursor: pointer;
                            }
                        }
                    }
                    .policies{
                        width: 100%;
                        line-height: 1.5;
                        .title{
                            font-size: 16px;
                            font-weight: 500;
                            color: #ff9275;
                            margin-bottom: 8px;
                        }
                        .list{
                            height: 329px;
                            overflow-x: hidden;
                            &::-webkit-scrollbar {
                                display: none;
                            }
                            .item{
                                .wrap{
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 12px;
                                    .policy{
                                        width: 712px;
                                    }
                                    >img{
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
                .btn-group{
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    bottom: 0;
                    button{
                        width: 200px;
                        height: 44px;
                        margin-bottom: 0px;
                        
                    }
                    .loading-wrap{
                        position: relative;
                        .btn-loading{
                            left: 64px;
                            top: 6px;
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/addPolicyToNow.vue